import { render, staticRenderFns } from "./saasExpSubcribe.vue?vue&type=template&id=61f2eb27"
import script from "./saasExpSubcribe.vue?vue&type=script&lang=js"
export * from "./saasExpSubcribe.vue?vue&type=script&lang=js"
import style0 from "./saasExpSubcribe.vue?vue&type=style&index=0&id=61f2eb27&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports